import { createReducer } from "../../common/reduxUtil";
import {
  SET_TASKS,
  APPEND_TASKS,
  SET_TOTAL,
  SET_STATS,
  SET_LOADING,
  SET_LOADING_MORE,
  SET_FILTERS,
  SET_SELECTED_TASK_ID,
  TOGGLE_HIDE_COMPLETED,
  SET_COMPLETED_TASKS,
  APPEND_COMPLETED_TASKS,
  SET_COMPLETED_TOTAL,
  SET_LOADING_MORE_COMPLETED,
} from "./types";

const initialState = {
  tasks: [],
  total: 0,
  stats: { activeTasks: 0, overdue: 0, dueToday: 0, dueSoon: 0 },
  loading: false,
  loadingMore: false,
  filters: {
    search: "",
    stage: "",
    deadline: "",
    priority: "",
    plan: "",
    service: "",
    sortBy: "priorityScore",
    assignedToEmail: "",
  },
  selectedTaskId: null,
  hideCompleted: true,
  completedTasks: [],
  completedTotal: 0,
  loadingMoreCompleted: false,
};

export default createReducer(initialState, {
  [SET_TASKS]: (state, payload) => {
    return Object.assign({}, state, { tasks: payload.tasks });
  },
  [APPEND_TASKS]: (state, payload) => {
    return Object.assign({}, state, {
      tasks: state.tasks.concat(payload.tasks),
    });
  },
  [SET_TOTAL]: (state, payload) => {
    return Object.assign({}, state, { total: payload.total });
  },
  [SET_STATS]: (state, payload) => {
    return Object.assign({}, state, { stats: payload.stats });
  },
  [SET_LOADING]: (state, payload) => {
    return Object.assign({}, state, { loading: payload.loading });
  },
  [SET_LOADING_MORE]: (state, payload) => {
    return Object.assign({}, state, { loadingMore: payload.loadingMore });
  },
  [SET_FILTERS]: (state, payload) => {
    return Object.assign({}, state, {
      filters: Object.assign({}, state.filters, payload.filters),
    });
  },
  [SET_SELECTED_TASK_ID]: (state, payload) => {
    return Object.assign({}, state, { selectedTaskId: payload.taskId });
  },
  [TOGGLE_HIDE_COMPLETED]: (state) => {
    return Object.assign({}, state, { hideCompleted: !state.hideCompleted });
  },
  [SET_COMPLETED_TASKS]: (state, payload) => {
    return Object.assign({}, state, {
      completedTasks: payload.completedTasks,
    });
  },
  [APPEND_COMPLETED_TASKS]: (state, payload) => {
    return Object.assign({}, state, {
      completedTasks: state.completedTasks.concat(payload.completedTasks),
    });
  },
  [SET_COMPLETED_TOTAL]: (state, payload) => {
    return Object.assign({}, state, {
      completedTotal: payload.completedTotal,
    });
  },
  [SET_LOADING_MORE_COMPLETED]: (state, payload) => {
    return Object.assign({}, state, {
      loadingMoreCompleted: payload.loadingMoreCompleted,
    });
  },
});
